export default "__VITE_ASSET__mqdN$Z33bK5c4V5ju81OPQ__"